import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-modify-customer-info',
  templateUrl: './modify-customer-info.component.html',
  styleUrls: ['./modify-customer-info.component.css']
})
export class ModifyCustomerInfoComponent implements OnInit {

  editForm: any | FormGroup
  paramData:any = []
  customerInfo: any = []
  imgUrl1 = ''
  imgUrl2 = ''
  file1: File | undefined;
  file2: File | undefined;
  singleCustomerInfo: any= []

  customerid: any = "";
  latitude: any;
  longitude: any;
  cid:any
  buttonDisable = false

  pageNumber1: number = 0;
  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getCustomerInfo(this.pageNumber,this.recordsPerPage)
    this.getCustomerParams()
    this.editForm = this.fb.group({
      name: [''],
      description: [''],
      address: [''],
      mobileNo1: [''],
      mobileNo2: [''],
      emailId: [''],
      image: [''],
      latitude:[''],
      longitude:[''],
      customerParamEntityList:this.fb.array([]),
    })
    this.addInfoObject()
  }

  onTableDataChange(event: any): void {
    this.pageNumber = event.target.value;
    this.getCustomerInfo(this.pageNumber-1,this.recordsPerPage);
  }

  get paramArr(){
    return this.editForm.get('customerParamEntityList') as FormArray;
  }

  paramObject(){
    return this.fb.group({
      "key": [''],
      "value": [''],
    })
   }
  
   addInfoObject(){
    // this.infoArr.clear()
    this.paramArr.push(this.paramObject())
   }

   removeParamObject(index: number){
    this.paramArr.removeAt(index)
   }

   updateCustomerInfo(){
    this.buttonDisable = true
    let body = {
      "customerInfoId": this.customerid,
      "version": 0,
      "isActive": true,
      "description": String(this.editForm.get('description').value),
      "name": String(this.editForm.get('name').value),
      "address": String(this.editForm.get('address').value),
      "geoAddress": {
        "latitude": String(this.editForm.get('latitude').value),
        "longitude":String(this.editForm.get('longitude').value)
      },
      "mobileNo1": String(this.editForm.get('mobileNo1').value),
      "mobileNo2": String(this.editForm.get('mobileNo2').value),
      "emailId": String(this.editForm.get('emailId').value),
      "customerParamEntityList": this.editForm.get('customerParamEntityList').value,
      "image": "string",
      "documents": [],
      "cid": this.cid
    }

    console.log(body)
    this.generic_service.updateCustomerInfo(body).subscribe(
      (response:any) => {
        console.log(response)
        this.getCustomerInfo(this.pageNumber-1,this.recordsPerPage)
        this.toastr.success("Successfully Updated")
        this.cancelModel()
        this.buttonDisable = false

      },
      (error:any)=>{
        console.log(error)
       this.buttonDisable = false

      }
    )
  }



  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getCustomerParams(){
    this.generic_service.getCustomerParams().subscribe(
      (res:any)=> {
        console.log(res)
        this.paramData = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  getCustomerInfo(pageNumber: any,recordsPerPage: any){
    this.generic_service.getCustomerInfo(pageNumber,recordsPerPage).subscribe(
      (res:any)=> {
        console.log(res)
        this.customerInfo = res.response.customerInfoList
        this.totalRecords = res.response.totalRecords
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  // onSelectFile(event: any) {
  //   this.file1 = event.target.files[0]
  //     // if (event.target.files) {
  //     //   var reader = new FileReader;
  //     //   reader.readAsDataURL(event.target.files[0]);
  //     //   reader.onload = (e: any) => {
  //     //     this.url1 = e.target.result
  //     //   }
  //     // }
  // }

  getCustomerInfoById(id:any){
    this.customerid = id
    this.generic_service.getCustomerInfoById(id).subscribe(
      (response:any)=>{
        console.log(response)
        this.singleCustomerInfo = []
        this.singleCustomerInfo.push(response.response)
        this.editForm.patchValue({
          name: response.response.name,
          description: response.response.description,
          address: response.response.address,
          mobileNo1: response.response.mobileNo1,
          mobileNo2: response.response.mobileNo2,
          emailId: response.response.emailId,
          latitude: response.response.geoAddress.latitude,
          longitude: response.response.geoAddress.longitude,
          customerParamEntityList: response.response.customerParamEntityList
        })
        console.log(this.editForm.value)
      },
      (err:any)=> {
        console.log(err)
      }
    )
  }

 
}
